export const items = [
  { name: 'Quiénes somos', route: '/#somos' },
  { name: 'Areas de acción', route: '/#accion' },
  { name: 'Servicios', route: '/#servicios' },
  { name: 'Productos', route: '/#productos' },
  { name: 'Contacto', route: '/#contacto' },
]
